<ng-template #content let-modal>
    <app-student-qr-modal-content [Student]="data"></app-student-qr-modal-content>
</ng-template>

<!-- <app-email-qr-modal #emailModal [openModalButtonVisible]="false"></app-email-qr-modal> -->

<span ngbTooltip="QR Login Code" (click)="openForNew()" class="ml-4 no-print"><i class="fal fa-qrcode pointer"></i></span>